module.exports = __webpack_public_path__ + "img/763-8d1b2a.png";